var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9877 3.78769C11.9723 2.80312 13.3076 2.25 14.7 2.25H17.4C17.8142 2.25 18.15 2.58579 18.15 3V6.6C18.15 7.01421 17.8142 7.35 17.4 7.35H14.7C14.6602 7.35 14.6221 7.3658 14.5939 7.39393C14.5658 7.42206 14.55 7.46022 14.55 7.5V9.45H17.4C17.631 9.45 17.849 9.5564 17.9912 9.73844C18.1333 9.92048 18.1836 10.1578 18.1276 10.3819L17.2276 13.9819C17.1441 14.3158 16.8442 14.55 16.5 14.55H14.55V21C14.55 21.4142 14.2142 21.75 13.8 21.75H10.2C9.78579 21.75 9.45 21.4142 9.45 21V14.55H7.5C7.08579 14.55 6.75 14.2142 6.75 13.8V10.2C6.75 9.78579 7.08579 9.45 7.5 9.45H9.45V7.5C9.45 6.10761 10.0031 4.77226 10.9877 3.78769ZM14.7 3.75C13.7054 3.75 12.7516 4.14509 12.0483 4.84835C11.3451 5.55161 10.95 6.50544 10.95 7.5V10.2C10.95 10.6142 10.6142 10.95 10.2 10.95H8.25V13.05H10.2C10.6142 13.05 10.95 13.3858 10.95 13.8V20.25H13.05V13.8C13.05 13.3858 13.3858 13.05 13.8 13.05H15.9144L16.4394 10.95H13.8C13.3858 10.95 13.05 10.6142 13.05 10.2V7.5C13.05 7.06239 13.2238 6.64271 13.5333 6.33327C13.8427 6.02384 14.2624 5.85 14.7 5.85H16.65V3.75H14.7Z",
    fill: "#0066CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.d8fc3c6cd4815dbebf6e33d925e45254.svg";
export { ForwardRef as ReactComponent };